const passThroughClicks = { pointerEvents: "none" };

const HomeIsland = ({
  windowDimensions,
  scale = 1,
  fillParent = false,
  zoomedIn = false,
  className,
  onClick = () => {},
  style = {},
  onPlaySong = () => {},
  color,
}) => (
  <svg
    width={fillParent ? "100%" : windowDimensions.width * windowDimensions.zoom}
    height={
      fillParent ? "100%" : windowDimensions.height * windowDimensions.zoom
    }
    viewBox={
      zoomedIn ? "90 110 410 410" : `0 0 ${2451 * scale} ${2550 * scale}`
    }
    preserveAspectRatio="xMidYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    className={className}
    style={style}
  >
    <mask
      id="path-1-outside-1"
      maskUnits="userSpaceOnUse"
      x="140.191"
      y="189.382"
      width="320"
      height="320"
      fill="black"
    >
      <rect fill="white" x="140.191" y="189.382" width="320" height="320" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M270.191 199.382C259.145 199.382 250.191 208.336 250.191 219.382V299.382L170.191 299.382C159.145 299.382 150.191 308.336 150.191 319.382L150.191 379.382C150.191 390.427 159.145 399.382 170.191 399.382H250.191V479.382C250.191 490.427 259.145 499.382 270.191 499.382H330.191C341.237 499.382 350.191 490.427 350.191 479.382V399.382H430.191C441.237 399.382 450.191 390.427 450.191 379.382V319.382C450.191 308.336 441.237 299.382 430.191 299.382L350.191 299.382V219.382C350.191 208.336 341.237 199.382 330.191 199.382H270.191Z"
      />
    </mask>
    <path
      d="M250.191 299.382V309.382H260.191V299.382H250.191ZM170.191 299.382V289.382V299.382ZM150.191 319.382H160.191H150.191ZM150.191 379.382H140.191H150.191ZM250.191 399.382H260.191V389.382H250.191V399.382ZM350.191 399.382V389.382H340.191V399.382H350.191ZM430.191 299.382V309.382V299.382ZM350.191 299.382H340.191V309.382H350.191V299.382ZM260.191 219.382C260.191 213.859 264.668 209.382 270.191 209.382V189.382C253.622 189.382 240.191 202.813 240.191 219.382H260.191ZM260.191 299.382V219.382H240.191V299.382H260.191ZM170.191 309.382L250.191 309.382L250.191 289.382L170.191 289.382L170.191 309.382ZM160.191 319.382C160.191 313.859 164.668 309.382 170.191 309.382V289.382C153.622 289.382 140.191 302.813 140.191 319.382H160.191ZM160.191 379.382L160.191 319.382H140.191L140.191 379.382H160.191ZM170.191 389.382C164.668 389.382 160.191 384.904 160.191 379.382H140.191C140.191 395.95 153.622 409.382 170.191 409.382V389.382ZM250.191 389.382H170.191V409.382H250.191V389.382ZM260.191 479.382V399.382H240.191V479.382H260.191ZM270.191 489.382C264.668 489.382 260.191 484.904 260.191 479.382H240.191C240.191 495.95 253.622 509.382 270.191 509.382V489.382ZM330.191 489.382H270.191V509.382H330.191V489.382ZM340.191 479.382C340.191 484.904 335.714 489.382 330.191 489.382V509.382C346.759 509.382 360.191 495.95 360.191 479.382H340.191ZM340.191 399.382V479.382H360.191V399.382H340.191ZM430.191 389.382H350.191V409.382H430.191V389.382ZM440.191 379.382C440.191 384.904 435.714 389.382 430.191 389.382V409.382C446.759 409.382 460.191 395.95 460.191 379.382H440.191ZM440.191 319.382V379.382H460.191V319.382H440.191ZM430.191 309.382C435.714 309.382 440.191 313.859 440.191 319.382H460.191C460.191 302.813 446.759 289.382 430.191 289.382V309.382ZM350.191 309.382L430.191 309.382V289.382L350.191 289.382V309.382ZM340.191 219.382V299.382H360.191V219.382H340.191ZM330.191 209.382C335.714 209.382 340.191 213.859 340.191 219.382H360.191C360.191 202.813 346.759 189.382 330.191 189.382V209.382ZM270.191 209.382H330.191V189.382H270.191V209.382Z"
      fill="#0B6FFB"
      mask="url(#path-1-outside-1)"
    />
    <mask id="path-3-inside-2" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M270.191 199.317C259.145 199.317 250.191 208.271 250.191 219.317V299.317L170.191 299.317C159.145 299.317 150.191 308.271 150.191 319.317L150.191 379.317C150.191 390.362 159.145 399.317 170.191 399.317H250.191V479.317C250.191 490.362 259.145 499.317 270.191 499.317H330.191C341.237 499.317 350.191 490.362 350.191 479.317V399.317H430.191C441.237 399.317 450.191 390.362 450.191 379.317V319.317C450.191 308.271 441.237 299.317 430.191 299.317L350.191 299.317V219.317C350.191 208.271 341.237 199.317 330.191 199.317H270.191Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M270.191 199.317C259.145 199.317 250.191 208.271 250.191 219.317V299.317L170.191 299.317C159.145 299.317 150.191 308.271 150.191 319.317L150.191 379.317C150.191 390.362 159.145 399.317 170.191 399.317H250.191V479.317C250.191 490.362 259.145 499.317 270.191 499.317H330.191C341.237 499.317 350.191 490.362 350.191 479.317V399.317H430.191C441.237 399.317 450.191 390.362 450.191 379.317V319.317C450.191 308.271 441.237 299.317 430.191 299.317L350.191 299.317V219.317C350.191 208.271 341.237 199.317 330.191 199.317H270.191Z"
      fill="#8F613C"
    />
    <path
      d="M250.191 299.317V301.317H252.191V299.317H250.191ZM170.191 299.317V297.317V299.317ZM150.191 319.317H152.191H150.191ZM150.191 379.317H148.191H150.191ZM250.191 399.317H252.191V397.317H250.191V399.317ZM350.191 399.317V397.317H348.191V399.317H350.191ZM430.191 299.317V301.317V299.317ZM350.191 299.317H348.191V301.317H350.191V299.317ZM252.191 219.317C252.191 209.376 260.25 201.317 270.191 201.317V197.317C258.041 197.317 248.191 207.166 248.191 219.317H252.191ZM252.191 299.317V219.317H248.191V299.317H252.191ZM170.191 301.317L250.191 301.317V297.317L170.191 297.317V301.317ZM152.191 319.317C152.191 309.376 160.25 301.317 170.191 301.317V297.317C158.041 297.317 148.191 307.166 148.191 319.317H152.191ZM152.191 379.317L152.191 319.317H148.191L148.191 379.317H152.191ZM170.191 397.317C160.25 397.317 152.191 389.258 152.191 379.317H148.191C148.191 391.467 158.041 401.317 170.191 401.317V397.317ZM250.191 397.317H170.191V401.317H250.191V397.317ZM252.191 479.317V399.317H248.191V479.317H252.191ZM270.191 497.317C260.25 497.317 252.191 489.258 252.191 479.317H248.191C248.191 491.467 258.041 501.317 270.191 501.317V497.317ZM330.191 497.317H270.191V501.317H330.191V497.317ZM348.191 479.317C348.191 489.258 340.132 497.317 330.191 497.317V501.317C342.341 501.317 352.191 491.467 352.191 479.317H348.191ZM348.191 399.317V479.317H352.191V399.317H348.191ZM430.191 397.317H350.191V401.317H430.191V397.317ZM448.191 379.317C448.191 389.258 440.132 397.317 430.191 397.317V401.317C442.341 401.317 452.191 391.467 452.191 379.317H448.191ZM448.191 319.317V379.317H452.191V319.317H448.191ZM430.191 301.317C440.132 301.317 448.191 309.376 448.191 319.317H452.191C452.191 307.166 442.341 297.317 430.191 297.317V301.317ZM350.191 301.317L430.191 301.317V297.317L350.191 297.317V301.317ZM348.191 219.317V299.317H352.191V219.317H348.191ZM330.191 201.317C340.132 201.317 348.191 209.376 348.191 219.317H352.191C352.191 207.166 342.341 197.317 330.191 197.317V201.317ZM270.191 201.317H330.191V197.317H270.191V201.317Z"
      fill="black"
      mask="url(#path-3-inside-2)"
    />
    <mask id="path-5-inside-3" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M270.191 149.317C259.145 149.317 250.191 158.271 250.191 169.317V249.317L170.191 249.317C159.145 249.317 150.191 258.271 150.191 269.317L150.191 329.317C150.191 340.362 159.145 349.317 170.191 349.317H250.191V429.317C250.191 440.362 259.145 449.317 270.191 449.317H330.191C341.237 449.317 350.191 440.362 350.191 429.317V349.317H430.191C441.237 349.317 450.191 340.362 450.191 329.317V269.317C450.191 258.271 441.237 249.317 430.191 249.317L350.191 249.317V169.317C350.191 158.271 341.237 149.317 330.191 149.317H270.191Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M270.191 149.317C259.145 149.317 250.191 158.271 250.191 169.317V249.317L170.191 249.317C159.145 249.317 150.191 258.271 150.191 269.317L150.191 329.317C150.191 340.362 159.145 349.317 170.191 349.317H250.191V429.317C250.191 440.362 259.145 449.317 270.191 449.317H330.191C341.237 449.317 350.191 440.362 350.191 429.317V349.317H430.191C441.237 349.317 450.191 340.362 450.191 329.317V269.317C450.191 258.271 441.237 249.317 430.191 249.317L350.191 249.317V169.317C350.191 158.271 341.237 149.317 330.191 149.317H270.191Z"
      fill="#61CA97"
    />
    <path
      d="M250.191 249.317V251.317H252.191V249.317H250.191ZM170.191 249.317V247.317V249.317ZM150.191 269.317H152.191H150.191ZM150.191 329.317H148.191H150.191ZM250.191 349.317H252.191V347.317H250.191V349.317ZM350.191 349.317V347.317H348.191V349.317H350.191ZM430.191 249.317V251.317V249.317ZM350.191 249.317H348.191V251.317H350.191V249.317ZM252.191 169.317C252.191 159.376 260.25 151.317 270.191 151.317V147.317C258.041 147.317 248.191 157.166 248.191 169.317H252.191ZM252.191 249.317V169.317H248.191V249.317H252.191ZM170.191 251.317L250.191 251.317V247.317L170.191 247.317V251.317ZM152.191 269.317C152.191 259.376 160.25 251.317 170.191 251.317V247.317C158.041 247.317 148.191 257.166 148.191 269.317H152.191ZM152.191 329.317L152.191 269.317H148.191L148.191 329.317H152.191ZM170.191 347.317C160.25 347.317 152.191 339.258 152.191 329.317H148.191C148.191 341.467 158.041 351.317 170.191 351.317V347.317ZM250.191 347.317H170.191V351.317H250.191V347.317ZM252.191 429.317V349.317H248.191V429.317H252.191ZM270.191 447.317C260.25 447.317 252.191 439.258 252.191 429.317H248.191C248.191 441.467 258.041 451.317 270.191 451.317V447.317ZM330.191 447.317H270.191V451.317H330.191V447.317ZM348.191 429.317C348.191 439.258 340.132 447.317 330.191 447.317V451.317C342.341 451.317 352.191 441.467 352.191 429.317H348.191ZM348.191 349.317V429.317H352.191V349.317H348.191ZM430.191 347.317H350.191V351.317H430.191V347.317ZM448.191 329.317C448.191 339.258 440.132 347.317 430.191 347.317V351.317C442.341 351.317 452.191 341.467 452.191 329.317H448.191ZM448.191 269.317V329.317H452.191V269.317H448.191ZM430.191 251.317C440.132 251.317 448.191 259.376 448.191 269.317H452.191C452.191 257.166 442.341 247.317 430.191 247.317V251.317ZM350.191 251.317L430.191 251.317V247.317L350.191 247.317V251.317ZM348.191 169.317V249.317H352.191V169.317H348.191ZM330.191 151.317C340.132 151.317 348.191 159.376 348.191 169.317H352.191C352.191 157.166 342.341 147.317 330.191 147.317V151.317ZM270.191 151.317H330.191V147.317H270.191V151.317Z"
      fill="black"
      mask="url(#path-5-inside-3)"
    />
    <path
      d="M170.191 398.317L169.191 348.317H171.191L170.191 398.317Z"
      fill="black"
    />
    <path
      d="M430.191 398.317L429.191 348.317H431.191L430.191 398.317Z"
      fill="black"
    />
    <path
      d="M270.191 498.317L269.191 448.317H271.191L270.191 498.317Z"
      fill="black"
    />
    <path
      d="M330.191 498.317L329.191 448.317H331.191L330.191 498.317Z"
      fill="black"
    />
    <circle cx="300.191" cy="299.317" r="20" fill="#FFFAE8" id="node-start" />
    <circle cx="200.191" cy="299.317" r="20" fill="#FFFAE8" id="node-art" />
    <circle cx="400.191" cy="299.317" r="20" fill="#FFFAE8" id="node-music" />
    <circle cx="300.191" cy="199.317" r="20" fill="#FFFAE8" id="node-avatar" />
    <circle cx="300.191" cy="399.317" r="20" fill="#FFFAE8" id="node-dance" />
    <rect
      x="310.191"
      y="199.317"
      width="200"
      height="20"
      transform="rotate(90 310.191 199.317)"
      fill="#FFFAE8"
      {...passThroughClicks}
    />
    <rect
      x="400.191"
      y="309.317"
      width="200"
      height="20"
      transform="rotate(-180 400.191 309.317)"
      fill="#FFFAE8"
      {...passThroughClicks}
    />
    <circle
      cx="200.249"
      cy="299.366"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="300.249"
      cy="199.366"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="400.249"
      cy="299.366"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="300.249"
      cy="399.366"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <rect
      x="342.168"
      y="248.683"
      width="28"
      height="8"
      transform="rotate(90 342.168 248.683)"
      fill="#986F4D"
      stroke="black"
      strokeWidth="2"
      id="node-signpost"
    />
    <rect
      x="324.168"
      y="247.683"
      width="28"
      height="18"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
      id="node-signpost"
    />
    <rect
      x="329.168"
      y="251.686"
      width="18"
      height="2"
      fill="black"
      {...passThroughClicks}
    />
    <rect
      x="329.168"
      y="255.683"
      width="18"
      height="2"
      fill="black"
      {...passThroughClicks}
    />
    <rect
      x="329.168"
      y="259.681"
      width="18"
      height="2"
      fill="black"
      {...passThroughClicks}
    />
    <path
      d="M328.592 251.694L324.564 250.677V252.732L328.592 251.694Z"
      fill="black"
      {...passThroughClicks}
    />
    <path
      d="M347.545 261.666L351.573 262.683L351.573 260.628L347.545 261.666Z"
      fill="black"
      {...passThroughClicks}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M279.167 435.599H284.61V438.321H271.002V435.599H276.445L276.445 423.352L279.167 423.352V435.599Z"
      fill="#767676"
    />
    <path
      d="M279.167 435.599H278.167V436.599H279.167V435.599ZM284.61 435.599H285.61V434.599H284.61V435.599ZM284.61 438.321V439.321H285.61V438.321H284.61ZM271.002 438.321H270.002V439.321H271.002V438.321ZM271.002 435.599V434.599H270.002V435.599H271.002ZM276.445 435.599V436.599H277.445V435.599H276.445ZM276.445 423.352V422.352L275.445 422.352V423.352L276.445 423.352ZM279.167 423.352H280.167V422.352H279.167V423.352ZM279.167 436.599H284.61V434.599H279.167V436.599ZM283.61 435.599V438.321H285.61V435.599H283.61ZM284.61 437.321H271.002V439.321H284.61V437.321ZM272.002 438.321V435.599H270.002V438.321H272.002ZM271.002 436.599H276.445V434.599H271.002V436.599ZM277.445 435.599L277.445 423.352L275.445 423.352L275.445 435.599H277.445ZM276.445 424.352L279.167 424.352V422.352L276.445 422.352V424.352ZM278.167 423.352V435.599H280.167V423.352H278.167Z"
      fill="black"
    />
    <path
      d="M278.245 373.366L280.165 416.053L267.712 420.822L240.249 387.916L278.245 373.366Z"
      fill="url(#paint0_linear)"
      id="left-spotlight"
    />
    <rect
      x="268.828"
      y="421.32"
      width="11.6077"
      height="11.6077"
      transform="rotate(-20.9533 268.828 421.32)"
      fill="#767676"
      stroke="black"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M321.645 435.599H316.202V438.32H329.81V435.599H324.367L324.367 423.352L321.645 423.352L321.645 435.599Z"
      fill="#767676"
    />
    <path
      d="M321.645 435.599H322.645V436.599H321.645V435.599ZM316.202 435.599H315.202V434.599H316.202V435.599ZM316.202 438.32V439.32H315.202V438.32H316.202ZM329.81 438.32H330.81V439.32H329.81V438.32ZM329.81 435.599V434.599H330.81V435.599H329.81ZM324.367 435.599V436.599H323.367V435.599H324.367ZM324.367 423.352V422.352L325.367 422.352V423.352L324.367 423.352ZM321.645 423.352L320.645 423.352V422.352H321.645V423.352ZM321.645 436.599H316.202V434.599H321.645V436.599ZM317.202 435.599V438.32H315.202V435.599H317.202ZM316.202 437.32H329.81V439.32H316.202V437.32ZM328.81 438.32V435.599H330.81V438.32H328.81ZM329.81 436.599H324.367V434.599H329.81V436.599ZM323.367 435.599L323.367 423.352L325.367 423.352L325.367 435.599H323.367ZM324.367 424.352L321.645 424.352V422.352L324.367 422.352V424.352ZM322.645 423.352L322.645 435.599H320.645L320.645 423.352L322.645 423.352Z"
      fill="black"
    />
    <path
      d="M322.568 373.366L320.647 416.053L333.101 420.822L360.564 387.916L322.568 373.366Z"
      fill="url(#paint1_linear)"
      id="right-spotlight"
    />
    <rect
      x="-1.29148"
      y="0.576266"
      width="11.6077"
      height="11.6077"
      transform="matrix(-0.933872 -0.357606 -0.357606 0.933872 330.985 420.32)"
      fill="#767676"
      stroke="black"
      strokeWidth="2"
    />
    <rect
      x="396.249"
      y="247.366"
      width="43"
      height="23"
      fill={color}
      stroke="black"
      strokeWidth="2"
      id="event-play-music"
      onClick={onPlaySong}
    />
    <circle
      cx="405.249"
      cy="261.366"
      r="5"
      fill="black"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="405.249"
      cy="261.366"
      r="2"
      fill="#DADADA"
      {...passThroughClicks}
    />
    <circle
      cx="430.249"
      cy="261.366"
      r="5"
      fill="black"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <rect
      x="414.249"
      y="257.366"
      width="7"
      height="6"
      fill="#0273F5"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <rect
      x="413.249"
      y="265.366"
      width="9"
      height="2"
      fill="black"
      {...passThroughClicks}
    />
    <rect
      x="399.249"
      y="250.366"
      width="37"
      height="3"
      fill="black"
      {...passThroughClicks}
    />
    <circle
      cx="430.249"
      cy="261.366"
      r="2"
      fill="#DADADA"
      {...passThroughClicks}
    />
    <rect
      x="408.249"
      y="242.366"
      width="19"
      height="5"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <rect
      x="178.249"
      y="231.366"
      width="6"
      height="6"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
    />
    <mask
      id="path-47-outside-4"
      maskUnits="userSpaceOnUse"
      x="170.249"
      y="263.366"
      width="22"
      height="14"
      fill="black"
    >
      <rect fill="white" x="170.249" y="263.366" width="22" height="14" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M179.249 265.366H183.249V269.366L189.249 274.366L181.249 272.366L173.249 274.366L179.249 269.366V265.366Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M179.249 265.366H183.249V269.366L189.249 274.366L181.249 272.366L173.249 274.366L179.249 269.366V265.366Z"
      fill="#CA9B71"
    />
    <path
      d="M183.249 265.366H185.249C185.249 264.262 184.353 263.366 183.249 263.366V265.366ZM179.249 265.366V263.366C178.144 263.366 177.249 264.262 177.249 265.366H179.249ZM183.249 269.366H181.249C181.249 269.96 181.512 270.523 181.968 270.903L183.249 269.366ZM189.249 274.366L188.763 276.306C189.668 276.533 190.609 276.103 191.032 275.272C191.454 274.44 191.245 273.427 190.529 272.83L189.249 274.366ZM181.249 272.366L181.734 270.426C181.415 270.346 181.082 270.346 180.763 270.426L181.249 272.366ZM173.249 274.366L171.968 272.83C171.252 273.427 171.043 274.44 171.465 275.272C171.888 276.103 172.829 276.533 173.734 276.306L173.249 274.366ZM179.249 269.366L180.529 270.903C180.985 270.523 181.249 269.96 181.249 269.366H179.249ZM183.249 263.366H179.249V267.366H183.249V263.366ZM185.249 269.366V265.366H181.249V269.366H185.249ZM181.968 270.903L187.968 275.903L190.529 272.83L184.529 267.83L181.968 270.903ZM189.734 272.426L181.734 270.426L180.763 274.306L188.763 276.306L189.734 272.426ZM173.734 276.306L181.734 274.306L180.763 270.426L172.763 272.426L173.734 276.306ZM177.968 267.83L171.968 272.83L174.529 275.903L180.529 270.903L177.968 267.83ZM177.249 265.366V269.366H181.249V265.366H177.249Z"
      fill="black"
      mask="url(#path-47-outside-4)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M181.249 246.366H174.249L169.249 265.366H181.249H193.249L187.749 246.366H181.249Z"
      fill="#CA9B71"
    />
    <path
      d="M174.249 246.366V245.366H173.478L173.281 246.112L174.249 246.366ZM169.249 265.366L168.281 265.112L167.951 266.366H169.249V265.366ZM193.249 265.366V266.366H194.579L194.209 265.088L193.249 265.366ZM187.749 246.366L188.709 246.088L188.5 245.366H187.749V246.366ZM174.249 247.366H181.249V245.366H174.249V247.366ZM170.216 265.621L175.216 246.621L173.281 246.112L168.281 265.112L170.216 265.621ZM181.249 264.366H169.249V266.366H181.249V264.366ZM181.249 266.366H193.249V264.366H181.249V266.366ZM194.209 265.088L188.709 246.088L186.788 246.644L192.288 265.644L194.209 265.088ZM187.749 245.366H181.249V247.366H187.749V245.366Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M167.249 262.366L170.249 248.033L166.249 250.922L161.249 244.144L171.249 236.366H181.249H191.249L201.249 244.144L196.249 250.922L192.249 248.033L195.249 262.366H181.249H167.249Z"
      fill="white"
    />
    <path
      d="M170.249 248.033L171.227 248.238L171.756 245.71L169.663 247.222L170.249 248.033ZM167.249 262.366L166.27 262.161L166.018 263.366H167.249V262.366ZM166.249 250.922L165.444 251.515L166.031 252.312L166.834 251.732L166.249 250.922ZM161.249 244.144L160.635 243.355L159.865 243.953L160.444 244.738L161.249 244.144ZM171.249 236.366V235.366H170.905L170.635 235.577L171.249 236.366ZM191.249 236.366L191.862 235.577L191.592 235.366H191.249V236.366ZM201.249 244.144L202.053 244.738L202.632 243.953L201.862 243.355L201.249 244.144ZM196.249 250.922L195.663 251.732L196.466 252.312L197.053 251.515L196.249 250.922ZM192.249 248.033L192.834 247.222L190.741 245.71L191.27 248.238L192.249 248.033ZM195.249 262.366V263.366H196.48L196.227 262.161L195.249 262.366ZM169.27 247.828L166.27 262.161L168.227 262.571L171.227 248.238L169.27 247.828ZM166.834 251.732L170.834 248.844L169.663 247.222L165.663 250.111L166.834 251.732ZM160.444 244.738L165.444 251.515L167.053 250.328L162.053 243.55L160.444 244.738ZM170.635 235.577L160.635 243.355L161.862 244.933L171.862 237.156L170.635 235.577ZM181.249 235.366H171.249V237.366H181.249V235.366ZM181.249 237.366H191.249V235.366H181.249V237.366ZM190.635 237.156L200.635 244.933L201.862 243.355L191.862 235.577L190.635 237.156ZM200.444 243.55L195.444 250.328L197.053 251.515L202.053 244.738L200.444 243.55ZM196.834 250.111L192.834 247.222L191.663 248.844L195.663 251.732L196.834 250.111ZM191.27 248.238L194.27 262.571L196.227 262.161L193.227 247.828L191.27 248.238ZM195.249 261.366H181.249V263.366H195.249V261.366ZM167.249 263.366H181.249V261.366H167.249V263.366Z"
      fill="black"
    />
    <mask
      id="path-53-outside-5"
      maskUnits="userSpaceOnUse"
      x="292.529"
      y="117.189"
      width="10.6568"
      height="17.1461"
      fill="black"
    >
      <rect
        fill="white"
        x="292.529"
        y="117.189"
        width="10.6568"
        height="17.1461"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M298.038 122.983C298.501 122.59 298.748 121.969 298.635 121.328C298.466 120.366 297.549 119.724 296.587 119.894C295.626 120.063 294.984 120.98 295.153 121.942C295.266 122.583 295.712 123.082 296.281 123.293L297.572 130.614C297.657 131.099 298.12 131.423 298.605 131.338C299.09 131.252 299.415 130.789 299.329 130.304L298.038 122.983Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M298.038 122.983C298.501 122.59 298.748 121.969 298.635 121.328C298.466 120.366 297.549 119.724 296.587 119.894C295.626 120.063 294.984 120.98 295.153 121.942C295.266 122.583 295.712 123.082 296.281 123.293L297.572 130.614C297.657 131.099 298.12 131.423 298.605 131.338C299.09 131.252 299.415 130.789 299.329 130.304L298.038 122.983Z"
      fill="#FF5739"
    />
    <path
      d="M298.038 122.983L296.743 121.459L295.869 122.202L296.069 123.33L298.038 122.983ZM296.281 123.293L298.25 122.946L298.051 121.817L296.976 121.418L296.281 123.293ZM297.572 130.614L295.602 130.961L297.572 130.614ZM299.333 124.507C300.315 123.673 300.846 122.349 300.605 120.98L296.666 121.675C296.651 121.588 296.687 121.507 296.743 121.459L299.333 124.507ZM300.605 120.98C300.244 118.931 298.289 117.563 296.24 117.924L296.935 121.863C296.808 121.885 296.688 121.801 296.666 121.675L300.605 120.98ZM296.24 117.924C294.191 118.285 292.822 120.24 293.184 122.289L297.123 121.594C297.145 121.721 297.061 121.841 296.935 121.863L296.24 117.924ZM293.184 122.289C293.425 123.658 294.378 124.72 295.585 125.168L296.976 121.418C297.046 121.444 297.108 121.508 297.123 121.594L293.184 122.289ZM294.311 123.64L295.602 130.961L299.541 130.267L298.25 122.946L294.311 123.64ZM295.602 130.961C295.879 132.534 297.38 133.585 298.953 133.307L298.258 129.368C298.861 129.262 299.435 129.664 299.541 130.267L295.602 130.961ZM298.953 133.307C300.526 133.03 301.576 131.53 301.299 129.957L297.359 130.651C297.253 130.049 297.655 129.474 298.258 129.368L298.953 133.307ZM301.299 129.957L300.008 122.636L296.069 123.33L297.359 130.651L301.299 129.957Z"
      fill="black"
      mask="url(#path-53-outside-5)"
    />
    <path
      d="M293.882 151.332L309.876 148.512C313.922 147.798 316.622 143.946 315.911 139.909L314.35 131.059C313.637 127.015 309.777 124.326 305.737 125.038L289.743 127.858C285.697 128.572 282.997 132.425 283.708 136.462L285.269 145.312C285.981 149.348 289.836 152.045 293.882 151.332Z"
      fill="#FF5739"
      stroke="black"
      strokeWidth="2"
    />
    <path
      d="M309.125 145.165L293.444 147.93C291.177 148.33 289.006 146.772 288.597 144.454L287.129 136.129C286.721 133.811 288.228 131.605 290.494 131.205L306.176 128.44C308.442 128.04 310.614 129.598 311.023 131.916L312.49 140.241C312.905 142.558 311.397 144.765 309.125 145.165Z"
      fill="black"
    />
    <path
      d="M300.545 142.287C299.717 142.433 298.872 142.126 298.332 141.482C298.23 141.362 298.245 141.186 298.365 141.084C298.486 140.982 298.662 140.997 298.764 141.118C299.173 141.605 299.821 141.843 300.447 141.733C301.074 141.622 301.603 141.183 301.819 140.579C301.874 140.431 302.034 140.356 302.182 140.411C302.33 140.466 302.405 140.626 302.35 140.774C302.062 141.563 301.368 142.142 300.545 142.287Z"
      fill="white"
      stroke="white"
    />
    <path
      d="M295.156 141.598L293.93 141.814C292.766 142.019 291.659 141.239 291.455 140.081L290.959 137.272C290.754 136.107 291.534 135 292.693 134.796L293.918 134.58C295.082 134.375 296.189 135.155 296.394 136.313L296.889 139.123C297.093 140.281 296.32 141.393 295.156 141.598Z"
      fill="white"
    />
    <path
      d="M306.595 139.581L305.369 139.797C304.205 140.002 303.098 139.222 302.894 138.064L302.398 135.254C302.193 134.09 302.973 132.983 304.132 132.779L305.357 132.563C306.521 132.358 307.628 133.138 307.833 134.296L308.328 137.106C308.532 138.264 307.759 139.376 306.595 139.581Z"
      fill="white"
    />
    <path
      d="M275.731 141.096C275.954 140.038 277.003 139.354 278.061 139.577L281.701 140.345C282.76 140.568 283.443 141.616 283.22 142.674C282.997 143.733 281.948 144.416 280.89 144.193L277.25 143.426C276.192 143.203 275.508 142.154 275.731 141.096Z"
      fill="black"
    />
    <path
      d="M278.659 137.694C278.882 136.635 279.931 135.952 280.989 136.175L284.645 136.945C285.703 137.169 286.387 138.217 286.164 139.275C285.941 140.334 284.892 141.017 283.834 140.794L280.178 140.023C279.119 139.8 278.436 138.752 278.659 137.694Z"
      fill="black"
    />
    <path
      d="M282.302 139.883L282.302 139.882C283.512 137.772 286.21 137.033 288.312 138.239L288.312 138.239L302.179 146.186L302.181 146.187C304.302 147.399 305.029 150.091 303.823 152.195C303.822 152.195 303.822 152.196 303.822 152.196L302.105 155.182L302.103 155.185C300.891 157.306 298.199 158.033 296.094 156.826L296.094 156.826L282.227 148.879L282.226 148.878C280.104 147.666 279.377 144.975 280.583 142.87C280.583 142.87 280.583 142.87 280.583 142.87C280.583 142.87 280.584 142.87 280.584 142.869L282.302 139.883Z"
      fill="white"
      stroke="black"
      strokeWidth="2"
    />
    <path
      d="M276.44 146.555C276.551 145.473 277.52 144.689 278.602 144.8L282.307 145.179C283.389 145.289 284.173 146.258 284.062 147.34C283.951 148.423 282.982 149.206 281.9 149.096L278.195 148.717C277.113 148.606 276.329 147.637 276.44 146.555Z"
      fill="black"
    />
    <path
      d="M314.039 148.06L313.173 147.56L312.673 148.426L310.03 153.004C309.166 154.5 307.245 155.015 305.748 154.151L303.329 152.754C301.824 151.885 301.317 149.971 302.182 148.473L306.892 140.314L307.393 139.446C308.257 137.95 310.178 137.435 311.675 138.299L314.094 139.696L319.237 142.665C320.733 143.529 321.248 145.45 320.384 146.946L319.883 147.814C319.019 149.311 317.098 149.825 315.601 148.962L314.039 148.06Z"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
    />
    <path
      opacity="0.2"
      d="M302.612 145.727L312.192 151.258L312.819 150.173L303.239 144.642L302.612 145.727Z"
      fill="black"
    />
    <rect
      x="286.249"
      y="151.366"
      width="28"
      height="18"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
    />
    <rect x="296.249" y="154.366" width="8" height="2" fill="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M480.249 648.366C491.294 648.366 500.249 639.412 500.249 628.366L500.249 548.366L580.249 548.366C591.294 548.366 600.249 539.412 600.249 528.366L600.249 468.366C600.249 457.321 591.294 448.366 580.249 448.366L480.249 448.366L420.249 448.366C410.282 448.366 402.018 455.656 400.499 465.195C400.334 466.228 400.249 467.287 400.249 468.366L400.249 528.366L400.249 628.366C400.249 639.412 409.203 648.366 420.249 648.366L480.249 648.366Z"
      fill="black"
      fillOpacity="0.07"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.249 20.3662C100.249 9.32052 109.203 0.366211 120.249 0.366211H180.249C191.294 0.366211 200.249 9.32052 200.249 20.3662V180.366C200.249 191.412 191.294 200.366 180.249 200.366H150.249H120.249H100.249V280.366C100.249 291.412 91.2942 300.366 80.2485 300.366H20.2485C9.20284 300.366 0.248535 291.412 0.248535 280.366V120.366C0.248535 109.321 9.20284 100.366 20.2485 100.366H50.2485H80.2485H100.249V20.3662Z"
      fill="black"
      fillOpacity="0.07"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="259.247"
        y1="380.641"
        x2="273.748"
        y2="418.511"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC700" stopOpacity="0" />
        <stop offset="1" stopColor="#FFC700" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="341.566"
        y1="380.641"
        x2="327.065"
        y2="418.511"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5739" stopOpacity="0" />
        <stop offset="1" stopColor="#FF5739" />
      </linearGradient>
    </defs>
  </svg>
);

HomeIsland.propTypes = {
  windowDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    zoom: PropTypes.number,
  }),
  scale: PropTypes.number,
  fillParent: PropTypes.bool,
  zoomedIn: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  onPlaySong: PropTypes.func,
  color: PropTypes.string,
};

export default HomeIsland;
